import PrivacyPolicyAgreementModal from '../../components/molecules/modals/agreement/PrivacyPolicyAgreementModal.vue'

export default {
  components: {
    PrivacyPolicyAgreementModal
  }
}
